import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const TriangleIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M1.875 17.5L10 2.5L18.125 17.5H1.875Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
